import { TextSortBy } from "nystem-components";

const EmailSortBy = (props) => <TextSortBy {...props} />;
export default EmailSortBy;
